export default "__VITE_ASSET__DBq7N$UX__"